module.exports = __webpack_public_path__ + "img/sv3.24a1a125.svg";